import { useCallback } from "react";
import { useRouter } from "./useRouter";
import { useRedirectUrlParam } from "./useRedirectUrlParam";

export const useRedirectToUrlParam = () => {
  const router = useRouter();
  const redirectUrl = useRedirectUrlParam();

  const redirectToUrlParam = useCallback(() => {
    router.replace(`/${redirectUrl}`);
  }, []);

  return {
    hasRedirectUrlParam: !!redirectUrl,
    redirectToUrlParam,
  };
};
